export class PutTableContextFileRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "content",
            "baseName": "content",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PutTableContextFileRequest.attributeTypeMap;
    }
    constructor() {
    }
}
